import { render, staticRenderFns } from "./LMSIntegration.vue?vue&type=template&id=ebeb54b2&"
import script from "./LMSIntegration.vue?vue&type=script&lang=js&"
export * from "./LMSIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Mihai Racoreanu\\Code\\bodyswaps\\bsportal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebeb54b2')) {
      api.createRecord('ebeb54b2', component.options)
    } else {
      api.reload('ebeb54b2', component.options)
    }
    module.hot.accept("./LMSIntegration.vue?vue&type=template&id=ebeb54b2&", function () {
      api.rerender('ebeb54b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/lms-integration/LMSIntegration.vue"
export default component.exports